const LAB_TO_NEW_LAB: Record<string, string> = {
  'lab.stemi.education': 'https://new-lab.stemi.education',
  'lab-review.stemi.education': 'https://new-lab-rc.stemi.education',
  'lab-develop.stemi.education': 'https://new-lab-develop.stemi.education',
  localhost: 'http://localhost:3000',
};

const getNewLabUrl = () => {
  const { hostname } = window.location;
  const newHostname = LAB_TO_NEW_LAB[hostname] || 'http://localhost:3000';
  return newHostname;
};

export default getNewLabUrl;
